const topics = [
  { tag: '古装权谋', count: '2.8万讨论', hot: true },
  { tag: '悬疑推理', count: '1.9万讨论', hot: true },
  { tag: '韩剧热播', count: '3.5万讨论', hot: true },
  { tag: '国产新剧', count: '4.2万讨论', hot: true },
  { tag: '都市爱情', count: '1.6万讨论', hot: false },
  { tag: '职场励志', count: '9800讨论', hot: false },
  { tag: '奇幻冒险', count: '1.3万讨论', hot: false },
  { tag: '家庭伦理', count: '7500讨论', hot: false },
  { tag: '经典重温', count: '2.1万讨论', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            大家都在讨论什么
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            当前最受关注的热门话题和剧集类型，看看剧迷们都在追什么
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4 max-w-3xl mx-auto">
          {topics.map((topic) => (
            <div
              key={topic.tag}
              className="relative group bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/50 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              {topic.hot && (
                <span className="absolute -top-1.5 -right-1.5 px-2 py-0.5 text-[10px] font-medium rounded-full bg-primary-500 text-white whitespace-nowrap">
                  热
                </span>
              )}
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-800 mb-1.5 group-hover:text-accent-600 transition-colors">
                {topic.tag}
              </h3>
              <div className="flex items-center gap-1.5 text-xs text-foreground-400">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-fire-line text-accent-400"></i>
                </span>
                <span>{topic.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}